import i18n from '../i18n';

export const getCurrentLanguage = () => {
  const lang = i18n.resolvedLanguage || i18n.language || 'en';
  return String(lang).toLowerCase().startsWith('nl') ? 'nl' : 'en';
};

// Legacy Order.status has been retired (see OrderDetail.js / TasksPage.js) — kept only so
// historical status values already displayed anywhere old still render a label rather than
// a raw enum string. Delivery Status is the single source of truth going forward.
export const translateOrderStatus = (status) => {
  if (!status) return '';
  return i18n.t(`orderStatuses.${status}`, { defaultValue: status });
};

export const translateDeliveryStatus = (status) => {
  if (!status) return '';
  return i18n.t(`deliveryStatuses.${status}`, { defaultValue: status });
};

export const translateRole = (role) => {
  if (!role) return i18n.t('header.roles.user');
  return i18n.t(`header.roles.${role}`, { defaultValue: role });
};

export const formatDateForLanguage = (value, options = {}) => {
  if (!value) return '-';
  const lang = getCurrentLanguage();
  const locale = lang === 'nl' ? 'nl-NL' : 'en-GB';
  return new Date(value).toLocaleDateString(locale, options);
};

// lang is explicit (not read from app i18n state) so callers with their own
// independent language toggle - e.g. the invoice preview, which always
// defaults to 'nl' regardless of the app's UI language - can force it.
// Omit lang to fall back to the app's current language.
export const formatEuroForLanguage = (amount, lang) => {
  const numeric = Number(amount) || 0;
  const resolvedLang = lang === 'nl' || lang === 'en' ? lang : getCurrentLanguage();
  const locale = resolvedLang === 'nl' ? 'nl-NL' : 'en-GB';
  return numeric.toLocaleString(locale, { style: 'currency', currency: 'EUR' });
};
